export default __webpack_public_path__ + "static/media/5049.80250944.png";